module.exports = __webpack_public_path__ + "static/media/lsu_logo.3694f830.svg";